export function init() {
  checkTileErrors();
}

export function accordionBehaviors(el) {
  const $el = $(el);
  const gotoHashTab = function(hash) {
    if (hash == null) {
      ({ hash } = window.location);
    }
    if (!hash) {
      return;
    }
    $el.find('.accordion-box').height(0);
    const active_tab = $el.find(hash + '.accordion-box');
    return active_tab && active_tab.height('auto');
  };

  gotoHashTab();

  $el.on('show', function(e) {
    // only do this if it's an accordion behavior
    if (!$(e.target).hasClass('accordion-box')) {
      return;
    }
    return (window.location.hash = e.target.id);
  });

  return $el.on('hide', function(e) {
    // only do this if it's an accordion behavior
    if (!$(e.target).hasClass('accordion-box')) {
      return;
    }
    return ICMIB.common.closePopovers(el);
  });
}

export function pageGuard(form) {
  const $form = $(form);
  const initial_values = $form.serialize();
  $(window).on('beforeunload', function() {
    if (initial_values !== $form.serialize()) {
      return 'You have unsaved changes on this page. Are you sure you want to leave without saving?';
    }
  });
  return $form.on('submit', () => $(window).off('beforeunload'));
}

// Takes an array of strings and creates a list of text fields
// to manage that array
export function textFieldList(list) {
  const $list = $(list);
  const items = $list.data('items');
  const generateTextField = function(value) {
    const $input = $(
      `<input type="text" name="${$list.data('name')}[]" />`
    ).val(value);
    return $('<li />').append($input);
  };

  const getFieldsAndValues = function(target) {
    const penultimate = $list.find('input').length - 2;
    return [
      $(target).val(),
      $list.find('input').last()[0],
      $list.find('input')[penultimate],
    ];
  };

  const handleKeyUp = function(e) {
    const [val, last, penultimate] = getFieldsAndValues(e.target);
    if (val.length && e.target === last) {
      return $list.append(generateTextField());
    } else if (!val.length && e.target === penultimate) {
      return $list
        .find('input')
        .last()
        .remove();
    }
  };

  const handleChange = function(e) {
    const [val, last] = getFieldsAndValues(e.target);
    if (!val.length && e.target !== last) {
      return $(e.target).remove();
    }
  };

  for (let item of Array.from(items)) {
    $list.append(generateTextField(item));
  }
  $list.append(generateTextField());

  return $list.on('keyup', handleKeyUp).on('keyup', handleChange);
}

export function slug(parent) {
  const handleInput = function(event) {
    const $target = $(event.target);
    const original_value = $target.val();
    const cleansed = window.Slugger.utils.replace($target.val());
    if (original_value !== cleansed) {
      let caretPos = $target.caret();
      $target.val(cleansed);
      caretPos += (original_value.length - cleansed.length) * -1;
      return $target.caret(caretPos);
    }
  };

  return $(parent).on('change input', handleInput);
}

export function checkboxToggle(target, checkbox) {
  const $target = $(target);
  const $checkbox = $(checkbox);
  if (!$target.length && !$checkbox.length) {
    return;
  }
  $checkbox.on('change', function() {
    return $target.toggle(this.checked);
  });
  return $target.toggle($checkbox[0].checked);
}

// Turns a link into a dropdown via bootstrap modal
// href must point to the div that contains modal content
export function dropdownDialogHandler(e, options) {
  if (options == null) {
    options = {};
  }
  e.preventDefault();
  const target = e.target.tagName === 'A' ? e.target : e.target.parentNode;
  const $modal = $(`#${target.href.split('#')[1]}`);
  if ($modal.hasClass('in')) {
    return $modal.modal('hide');
  }
  return $modal.modal('show');
}

function checkTileErrors() {
  if (ICMIB.tileFailed) {
    return window.alert(
      'At least one tile failed to load. Check the javascript console for more details'
    );
  }
}

export function startEditInPlace(tile, fields) {
  if (fields == null) {
    fields = '.til-hdr-txt, .til-ttl, .til-desc';
  }

  if (tile.data('editables')) {
    tile.data('editables').elements.each(function() {
      if ($.trim($(this).text()) === '') {
        return $(this).addClass('medium-editor-placeholder');
      }
    });
    tile.data('editables').elements.addClass('highlight-editable');
    return tile.data('editables').activate();
  }

  const startEditors = () =>
    import('../vendor/medium-editor').then(function() {
      const editables = new window.MediumEditor(tile.find(fields), {
        buttons: [
          'bold',
          'italic',
          'underline',
          'anchor',
          'orderedlist',
          'unorderedlist',
        ],
        targetBlank: true,
      });
      // Handle 'paste' event
      editables.elements.on('paste', function(event) {
        // Remove unwanted <p> tags from the content
        let cleanedContent = $(this).html().replace(/<\/?p[^>]*>/g, '');
        $(this).html(cleanedContent);
        handleEditorChange.call(this);
      });
      editables.elements.on('input keyup', function() {
        handleEditorChange.call(this);
      });
      editables.elements.addClass('highlight-editable');
      return tile.data('editables', editables);
    }, 'medium-editor');

  return startEditors();
}

function handleEditorChange() {
  const $this = $(this);
  const value = $.trim($this.html());
  return $(`#${$this.data('field')}`)
    .val(value)
    .data('dirty', value !== '');
}

export function stopEditInPlace(tile) {
  tile
    .data('editables')
    .elements.removeClass('medium-editor-placeholder highlight-editable');
  return tile.data('editables').deactivate();
}

export function startPageGuard() {
  return $(window).on(
    'beforeunload',
    () => "If you leave the page now, you're unsaved changes will be lost."
  );
}

export function stopPageGuard() {
  return $(window).off('beforeunload');
}

export function disableEditButton() {
  return $('#edit-tiles')
    .addClass('disabled')
    .attr('href', 'javascript:void(0);')
    .off('click');
}
